import Slider from '../components/blocks/slider/Slider'

export const localiseContent = (content) => {
    const page = content.map(page => {
        const blocks = page.content_blocks.map(block => {
            if(block.locale === 1) {
                return block
            }
        })
        return page, blocks
    })
    return page
}

export const filterPublishedContent = (content) => {
    const publishedContent = content.filter(page => page.is_published || page.is_published === null)

    return publishedContent
}

/**
 * After i18n relinking, Strapi may occasionally return the same dynamic-zone row twice
 * (same __component + id). Deduplicate by stable component identity.
 */
export const dedupeDynamicZoneRows = (rows) => {
    if (!Array.isArray(rows)) {
        return rows
    }
    const seen = new Set()
    return rows.filter((row) => {
        if (!row || typeof row !== 'object') {
            return true
        }
        const comp = row.__component
        const id = row.id
        if (comp && id != null) {
            const key = `${comp}:${id}`
            if (seen.has(key)) {
                return false
            }
            seen.add(key)
        }
        return true
    })
}

/**
 * Avoid rendering the same page twice if the API returns duplicate entries.
 * After i18n relinks, SQLite can contain two rows with the same slug+locale+documentId
 * (different numeric id). Dedupe by slug+locale, not by id — otherwise both pass through
 * when documentId was omitted from the API fields list.
 */
export const dedupePagesByIdentity = (pages) => {
    if (!Array.isArray(pages) || pages.length <= 1) {
        return pages
    }
    const seen = new Set()
    return pages.filter((p) => {
        if (!p || typeof p !== 'object') {
            return true
        }
        const cat =
            p.category && typeof p.category === 'object' ? p.category.slug || '' : ''
        const key = p.is_home
            ? `home:${p.locale || ''}`
            : `${cat}:${p.slug || ''}:${p.locale || ''}`
        if (seen.has(key)) {
            return false
        }
        seen.add(key)
        return true
    })
}

/**
 * Normalize page detail API results for safe rendering.
 */
export const normalizePageDetailResponse = (pages) => {
    const list = dedupePagesByIdentity(pages)
    return list.map((page) => ({
        ...page,
        rows: dedupeDynamicZoneRows(page.rows),
    }))
}

export const orderArrayByProperty = (property) => {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

export const getPage = (content, slug) => {
    const page = content.filter(page => page.slug === slug)
    
    return page
}

export const returnComponent = (component) => {
    const componentCollection = [{
        'block-type.image-text' : <Slider />
    }]
    const chosen = componentCollection.map(collectionItem => {
        return collectionItem.component
    })
    return chosen
}

export const getBackgroundImage = (image, isLarge) => {
    const adminUrl = `${process.env.REACT_APP_CDP_API_URL}`
    const placeholderUrl = 'https://trirama.com/wp-content/uploads/2016/10/orionthemes-placeholder-image.png'
    let imageSize = placeholderUrl

    if(!image) {
        return imageSize
    } 

    // If no formats but has direct url, use it
    if(!image.formats || image === undefined) {
        return image.url ? adminUrl + image.url : imageSize
    }
    // console.log("is image!", isLarge, image)
    if(!isLarge || isLarge === undefined) {
        // console.log("is not large image!", isLarge, image.formats)
        // Try medium → small → thumbnail → main url → placeholder
        return imageSize =  
            (image.formats.medium?.url) ? 
                adminUrl + image.formats.medium.url 
            : (image.formats.small?.url) ? 
                adminUrl + image.formats.small.url 
            : (image.formats.thumbnail?.url) ?
                adminUrl + image.formats.thumbnail.url
            : (image.url) ?
                adminUrl + image.url
            : placeholderUrl
    }
    // console.log("is large image!", isLarge, image)
    // Try main url → large → medium → small → thumbnail → placeholder
    return imageSize = (image?.url) ? adminUrl + image.url 
        : (image.formats.large?.url) ? adminUrl + image.formats.large.url 
        : (image.formats.medium?.url) ? adminUrl + image.formats.medium.url
        : (image.url) ? adminUrl + image.url
        : (image.formats.small?.url) ? adminUrl + image.formats.small.url
        : (image.formats.thumbnail?.url) ? adminUrl + image.formats.thumbnail.url
        : placeholderUrl
    
}

export const shuffleArray = (array) => {
    let currentIndex = array.length,  randomIndex;
  
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }
  
    return array;
  }